
export const wrap_snippet = (code) => `%${code}%`
